import { useContext, useLayoutEffect, useState } from "react";
import { Subject } from "rxjs/internal/Subject";
import { distinctUntilChanged } from "rxjs/operators";
import { FormContext } from "./FormContext";
import {
  IFormContextValue,
  IFormState,
  TChildrenRender,
  IFieldAction
} from "./formInterfaces";

interface IFormValuesInnerProps {
  action: IFieldAction;
  formState: IFormState;
  updateFormValues: IFormContextValue["updateFormValues"];
  updateFormState: IFormContextValue["updateFormState"];
}

type Props = {
  children: TChildrenRender<IFormValuesInnerProps>;
};

export const FieldValueOnChange: React.FC<Props> = props => {
  const { updateFormValues, updateFormState, subscribeFormAction } = useContext(
    FormContext
  );

  const [action, setAction] = useState();
  const [formState, setFormState] = useState();

  useLayoutEffect(() => {
    const actionAndFormStateObserver$ = new Subject<
      [IFieldAction, IFormState]
    >();
    actionAndFormStateObserver$
      .pipe(distinctUntilChanged((next, prev) => next[0] === prev[0]))
      .subscribe(([action, formState]) => {
        setAction(action);
        setFormState(formState);
      });

    const subscription = subscribeFormAction(actionAndFormStateObserver$);

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!action) return null;

  return props.children({
    action,
    formState,
    updateFormValues,
    updateFormState
  });
};
